// extracted by mini-css-extract-plugin
module.exports = {"hero-stats":"HeroStats_hero-stats__mqeJF","hero-stats--content":"HeroStats_hero-stats--content__aBb0P"};